import { HTTPError } from 'ky';
import { tempoApi } from '@/common/api/tempoApi';
import type { OrganizationCurrency } from '@/features/settings/organization-currency/api/types/organizationCurrency';

const PATH = 'api/v1/finance/organization-currency';

// Mirrors the finance service's own default (currency.service.ts) so that a
// frontend deployed ahead of that backend change still degrades to the same
// default during the rollout window, instead of surfacing a request error.
const DEFAULT_CURRENCY: OrganizationCurrency = { currencyCode: 'USD' };

const getOrganizationCurrency = async (): Promise<OrganizationCurrency> => {
  try {
    return await tempoApi().get(PATH).json<OrganizationCurrency>();
  } catch (error) {
    if (error instanceof HTTPError && error.response.status === 404) {
      return DEFAULT_CURRENCY;
    }
    throw error;
  }
};

const setOrganizationCurrency = async (currencyCode: string): Promise<OrganizationCurrency> => {
  return await tempoApi().put(PATH, { json: { currencyCode } }).json<OrganizationCurrency>();
};

export const OrganizationCurrencyApi = {
  getOrganizationCurrency,
  setOrganizationCurrency,
};
